const getByKeys = <T extends Record<string, any>>(obj: T | undefined, keys: string[]): string => {
  if (!obj) return '';
  for (const k of keys) {
    const v = obj[k];
    if (typeof v === 'string' && v.length) return v;
  }
  for (const k of keys) {
    const v = obj[k];
    if (v != null) return String(v);
  }
  return '';
};

export const sortByStringKeys = <T extends Record<string, any>>(arr: T[] = [], keys: string[]): T[] => {
  return [...arr].sort((a, b) => getByKeys(a, keys).localeCompare(getByKeys(b, keys)));
};

export const sortByLabel = <T extends { label?: string }>(arr: T[] = []): T[] => {
  return sortByStringKeys(arr as Record<string, any>[], ['label']) as T[];
};

export const sortByLabelOrName = <T extends { label?: string; name?: string }>(arr: T[] = []): T[] => {
  return sortByStringKeys(arr as Record<string, any>[], ['label', 'name']) as T[];
};
